import type { OrganizationLLMResolvedConfig } from '@/services/api/runtimeTypes'
import type { StandaloneSetupStatus } from '@/services/api/standaloneSetup'
import {
  inferAccessModeFromServer,
  isAgentMauriceResolvedConfig,
  isHostedRuntimeConfigured,
  type AgentAccessMode,
} from '@/services/accessMode'

interface StandaloneOnboardingState {
  status: StandaloneSetupStatus
  resolvedLLMConfig: OrganizationLLMResolvedConfig | null
  storedAccessMode: AgentAccessMode | null
  organizationId: string | null
  deploymentId: string | null
  allowMissingProvider?: boolean
}

export function needsStandaloneOnboarding({
  status,
  resolvedLLMConfig,
  storedAccessMode,
  organizationId,
  deploymentId,
  allowMissingProvider = false,
}: StandaloneOnboardingState): boolean {
  const serverAccessMode = inferAccessModeFromServer(status, resolvedLLMConfig)
  const accessMode = serverAccessMode || storedAccessMode
  const missingContext =
    !(organizationId || status.organizationId) ||
    !(deploymentId || status.deploymentId)

  if (allowMissingProvider) {
    return missingContext
  }

  const hostedReady =
    isAgentMauriceResolvedConfig(resolvedLLMConfig) ||
    Boolean(status.configured && isHostedRuntimeConfigured(status))
  const providerReady =
    accessMode === 'hosted'
      ? hostedReady
      : Boolean(status.configured || resolvedLLMConfig)

  return !accessMode || missingContext || !providerReady
}
